import { useDashboard, useHasEnabledFeatures, useTeam } from '@vrplatform/data';
import { LoadingIndicator } from '@vrplatform/components-legacy';
import { XIMPLIFI_TENANT_ID } from '@vrplatform/ui-common';
import { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { lazyWithRetry } from './_utils';

const FeaturesView = lazyWithRetry(() => import('../../views/features'));
const SettingsView = lazyWithRetry(() => import('../../views/settings'));

const PartnerDashboardView = lazyWithRetry(
  () => import('../../views/partner-dashboard')
);
const PartnerAutomationsView = lazyWithRetry(
  () => import('../../views/partner-automations')
);
const PartnerConnectionsView = lazyWithRetry(
  () => import('../../views/partner-connections')
);
const PartnerMembersView = lazyWithRetry(
  () => import('../../views/partner-members')
);
const PartnerBillingView = lazyWithRetry(
  () => import('../../views/partner-billing')
);
const PartnerOwnerStatementsView = lazyWithRetry(
  () => import('../../views/partner-statements')
);

const LineMasterListView = lazyWithRetry(
  () => import('../../views/partner-line-master')
);
const LegacyReportsView = lazyWithRetry(
  () => import('../../views/reports/ReportsView')
);

export const PartnerRoutes = () => {
  const hasEnabledFeatures = useHasEnabledFeatures();

  const [{ id: teamId }] = useTeam();
  const [dashboard] = useDashboard();

  const isXimplifiTeam = teamId === XIMPLIFI_TENANT_ID;
  const isPartnerDashboard = dashboard === 'partner';

  return (
    <Suspense fallback={<LoadingIndicator isFullPageLoading />}>
      <Routes>
        {isXimplifiTeam && isPartnerDashboard && (
          <Route path="line-master-list" element={<LineMasterListView />} />
        )}

        <Route path="dashboard">
          <Route
            index
            element={<Navigate to="/dashboard/overview" replace />}
          />
          <Route path=":tabValue" element={<PartnerDashboardView />} />
        </Route>

        <Route path="members" element={<PartnerMembersView />} />
        <Route path="billing" element={<PartnerBillingView />} />

        <Route path="team-statements">
          <Route
            index
            element={
              <Navigate to="/team-statements/owner-statements" replace />
            }
          />
          <Route path=":tabValue" element={<PartnerOwnerStatementsView />} />
        </Route>

        <Route path="team-automations">
          <Route
            index
            element={<Navigate to="/team-automations/overview" replace />}
          />
          <Route path=":tabValue" element={<PartnerAutomationsView />} />
        </Route>

        <Route path="team-connections">
          <Route index element={<PartnerConnectionsView />} />
          <Route path=":tabValue" element={<PartnerConnectionsView />} />
        </Route>

        {hasEnabledFeatures && (
          <Route path="features">
            <Route path=":tabValue" element={<FeaturesView />} />
            <Route index element={<Navigate to="features" replace />} />
          </Route>
        )}

        <Route path="reports">
          <Route index element={<LegacyReportsView />} />
          <Route path=":id" element={<LegacyReportsView />} />
        </Route>

        {/* user settings */}
        <Route path="settings/*" element={<SettingsView />} />

        {/* catch all */}
        <Route
          path="*"
          element={<Navigate to="/dashboard/overview" replace />}
        />
      </Routes>
    </Suspense>
  );
};
